import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { Container } from "pixi.js";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";

export class FeaturePot extends DisplayObject {
    private triggeringFeatureContainer: Container = new Container();
    public greenFeatureIndicator: Spine | null = null;
    public blueFeatureIndicator: Spine | null = null;
    public redFeatureIndicator: Spine | null = null;

    constructor(config: IDisplayObject) {
        super(config);
        this.init();
    }

    private init(): void {
        this.greenFeatureIndicator = Spine.from({
            skeleton: "oceanTriggerIndicatorSkel",
            atlas: "oceanTriggerIndicatorAtlas",
        });

        //blue pot
        this.blueFeatureIndicator = Spine.from({
            skeleton: "lightTriggerIndicatorSkel",
            atlas: "lightTriggerIndicatorAtlas",
        });

        //pink pot
        this.redFeatureIndicator = Spine.from({
            skeleton: "infernoTriggerIndicatorSkel",
            atlas: "infernoTriggerIndicatorAtlas",
        });

        this.triggeringFeatureContainer.position.set(8, -230);
        this.triggeringFeatureContainer.label = "Triggering Feature Container";



        this.greenFeatureIndicator.state.setAnimation(0, "loop", true);
        this.greenFeatureIndicator.position.set(250, -136);
        this.greenFeatureIndicator.label = "Green Pot";
        this.triggeringFeatureContainer.addChild(this.greenFeatureIndicator);



        this.blueFeatureIndicator.state.setAnimation(0, "loop", true);
        this.blueFeatureIndicator.position.set(-250, -140);
        this.blueFeatureIndicator.label = "Blue Pot";
        this.triggeringFeatureContainer.addChild(this.blueFeatureIndicator);



        this.redFeatureIndicator.state.setAnimation(0, "loop", true);
        this.redFeatureIndicator.position.set(0, -140);
        this.redFeatureIndicator.label = "Pink Pot";
        this.triggeringFeatureContainer.addChild(this.redFeatureIndicator);

        this.wireIndicatorReturnToIdle(this.greenFeatureIndicator);
        this.wireIndicatorReturnToIdle(this.blueFeatureIndicator);
        this.wireIndicatorReturnToIdle(this.redFeatureIndicator);

        this.addChild(this.triggeringFeatureContainer);
    }

    /** After trail hit one-shots (`collect`, `trigger`), resume the idle loop. */
    private wireIndicatorReturnToIdle(indicator: Spine): void {
        indicator.state.addListener({
            complete: (entry) => {
                const name = entry.animation?.name;
                if (name && ["collect", "trigger", "triger"].includes(name)) {
                    indicator.state.setAnimation(0, "loop", true);
                }
            },
        });
    }
}